import { selection } from 'd3-selection';
import 'd3-transition';

type D3TransitionChain = {
  transition: () => D3TransitionChain;
  duration: () => D3TransitionChain;
  ease: () => D3TransitionChain;
  attr: () => D3TransitionChain;
  attrTween: () => D3TransitionChain;
  style: () => D3TransitionChain;
};

// ngx-charts calls selection.transition() in lazy chunks. `ng serve` often
// shares one d3-selection; `ng build` can leave transition unpatched.
if (typeof (selection.prototype as { transition?: unknown }).transition !== 'function') {
  const chain = (): D3TransitionChain => {
    const t = {} as D3TransitionChain;
    t.transition = chain;
    t.duration = chain;
    t.ease = chain;
    t.attr = chain;
    t.attrTween = chain;
    t.style = chain;
    return t;
  };
  (selection.prototype as { transition: () => D3TransitionChain }).transition = chain;
}
